export default "__VITE_ASSET__C8W$OqLA__"